/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, PropsWithChildren } from "react";
import {
  Auth0Provider,
  Auth0ProviderOptions,
  AppState,
} from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

export const Auth0ProviderWithRedirectCallback: FC<
  PropsWithChildren<Auth0ProviderOptions>
> = ({ children, ...props }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname, {
      replace: true,
    });
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};
